/*
    User profile container.
*/

import React from 'react'
import { connect } from 'react-redux'
import { func } from 'prop-types'

import { resetChangePasswordStatus, logoutUser, requestDeleteUser } from 'models/user/actions'
import { getCurrentUser } from 'models/user/selectors'
import Profile from 'components/profile/Profile'

import { userType } from 'models/propTypes'

const ProfileContainer = ({ user, resetChangePassword, logout, deleteUser }) => (
    <Profile user={user} resetChangePassword={resetChangePassword} logout={logout} deleteUser={deleteUser} />
)

ProfileContainer.propTypes = {
    user: userType.isRequired,
    resetChangePassword: func.isRequired,
    logout: func.isRequired,
    deleteUser: func.isRequired,
}

const mapStateToProps = (state) => ({
    user: getCurrentUser(state),
})

const mapDispatchToProps = (dispatch) => ({
    resetChangePassword: () => dispatch(resetChangePasswordStatus()),
    logout: () => dispatch(logoutUser()),
    deleteUser: () => dispatch(requestDeleteUser()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer)
